<script>
	import Slider from '../States/Slider';

	export let index;

	let properties = {};
	let active = false;

	function updateSlider(slides) {
		active = Slider.check(index, 'missing', properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;
		}
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	.button {
		text-align: left;
		color: var(--primary-color);
	}

	.button i {
		font-size: 1.25em;
		text-align: center;
		color: var(--tertiary-color);
		vertical-align: middle;
		margin-right: .5em;
		width: 1.25em;
	}
</style>

<div class="box feature" class:active>
	<div class="menu">
		<div class="begin"></div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content">
		<h1>Deze pagina kan niet gevonden worden.</h1>
		<h2>Waarschijnlijk is de pagina verplaatst of verwijderd.</h2>
		<div class="button" on:click="{event => Slider.route('start')}">
			<i class="fad fa-home"></i> Naar de start pagina
		</div>
	</div>
</div>